module.exports = __webpack_public_path__ + "img/img_main@2x.63c46b0e.png";